export default function getGtmId(pathname: string) {
    const aux = pathname.split('/')
    if (aux.length > 3) {
        return('GTM-' + aux[aux.length - 3] + '-' + aux[aux.length - 2])
    } else {
        return('GTM-' + aux[aux.length - 2])
    }
}
